import { CgSpinner } from "react-icons/cg";
import icon from "./assets/icon.jpg";
import backgroundImage from "./assets/dashboardimage.jpg";
import reportimage from "./assets/report.jpg";
// import retailrocketimage from "./assets/retailrocket.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import OtpInput from "otp-input-react";
import { useState, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInWithPopup,
} from "firebase/auth";
import googleLogo from "./assets/googleimage.jpg";
import {
  checkUserBusiness,
  createUser,
  getDecodedToken,
  hasBusiness,
  sendEmail,
} from "./services/auth.service";
import { useNavigate } from "react-router-dom";
import BusinessForm from "./components/business/BusinessForm";
import LanguageChangerlogin from "./components/languageForloginpage";
import VerifyEmailPopup from "./components/business/emailverification";
import { generateSixDigitCode, toAlphanumeric } from "./helpers/util";
import ForgotPassword from "./components/business/forgotpassword";
import { TextField } from "@mui/material";
import EmployeeLogin from "./components/business/employeeLogin";
import ResellerLogin from "./components/business/resellerLogin";
import { OWNER_ADMIN, RESELLER } from "./components/common/utlity/constant";
import SignupForm from "./pages/userRegistration";
import ResellerSignupForm from "./pages/ResellerSignupForm";
import { motion, AnimatePresence } from "framer-motion";
import { createReseller } from "./services/auth.service";

import { auth, provider } from "./firebase.config";
import {
  FiArrowRight,
  FiCheckCircle,
  FiLogIn,
  FiUserPlus,
  FiShield,
  FiLock,
  FiTrendingUp,
  FiUsers,
  FiBarChart2,
  FiStar,
  FiAward,
  FiGlobe,
  FiSun,
  FiMoon,
  FiChevronRight,
  FiZap,
  FiClock,
} from "react-icons/fi";
import { syncTracking } from "./components/common/utlity/tracking";
import { getFingerprint } from "./helpers/fingerprint";
import { startAuthentication } from "@simplewebauthn/browser";
import { passkeyService } from "./services/passkey.service";
import { MdFingerprint } from "react-icons/md";
import { resolveDomain } from "./services/seo.service";

function App() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [user, setUser] = useState(null);
  const [timer, setTimer] = useState(30);
  const [emailOtp] = useState(generateSixDigitCode());
  const [showVerifyEmail, setShowVerigyEmail] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [employeeLogin, setEmployeeLogin] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showSignup, setShowSignup] = useState(false);
  const [showResellerSignup, setShowResellerSignup] = useState(false);
  const [showResellerLogin, setShowResellerLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showeyePassword, setShoweyePassword] = useState(false);
  const [signupDetails, setSignupDetails] = useState({});
  const [error, setError] = useState("");
// for custom domain
useEffect(() => {
  const handleCustomDomain = async () => {
    const host = window.location.hostname;

    if (!host.includes("dukanbuddy.com")) {
      try {
        const res = await resolveDomain(host);

        if (res?.data?.success) {
          const path = window.location.pathname;

          if (!path.includes("/store/")) {
            window.location.replace(`/store/${res.data.businessUuid}`);
          }
        }
      } catch (err) {
        console.log("Domain resolve failed");
      }
    }
  };

  handleCustomDomain();
}, []);
  // Initialize theme from localStorage or system preference
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme;

    // Check system preference
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "dark";
    }
    return "light";
  });

  const [business, setBusiness] = useState({
    email: "",
    password: "",
    phone: "",
    fullName: "",
    businessName: "",
    businessCategory: "",
    businessOtherCategory: "",
    pincode: "",
  });

  // Apply theme to document
  useEffect(() => {
    const root = window.document.documentElement;

    if (theme === "dark") {
      root.classList.add("dark");
      root.classList.remove("light");
    } else {
      root.classList.add("light");
      root.classList.remove("dark");
    }

    // Save theme preference to localStorage
    localStorage.setItem("theme", theme);

    // Update toast container theme
    const toastContainer = document.querySelector(".Toastify");
    if (toastContainer) {
      if (theme === "dark") {
        toastContainer.classList.add("toastify-dark");
        toastContainer.classList.remove("toastify-light");
      } else {
        toastContainer.classList.add("toastify-light");
        toastContainer.classList.remove("toastify-dark");
      }
    }
  }, [theme]);

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e) => {
      // Only auto-change if user hasn't manually set a preference
      if (!localStorage.getItem("theme")) {
        setTheme(e.matches ? "dark" : "light");
      }
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => {},
          "expired-callback": () => {},
        },
        auth,
      );
    }
  }

  function onOTPVerify() {
    setLoading(true);
    window.confirmationResult
      .confirm(otp)
      .then(async (res) => {
        await checkUser({ phone });
        setUser(res.user);
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Invalid OTP");
        setLoading(false);
      });
  }

  const handleGoogleSignIn = () => {
    signInWithPopup(auth, provider).then(async (data) => {
      const result = await checkUser({ email: data.user.email });
      if (result === "rejected") {
        toast.error(
          "Your account has been rejected. Please contact support for assistance.",
        );
        return;
      }
      // If checkUser returned true (logged in) or has existing approved business, skip business form
      if (result === true) {
        return;
      }
      // Only show business form for new users
      setBusiness((b) => {
        b.email = data.user?.email;
        b.fullName = data?.user?.displayName;
        return b;
      });
      setUser(data.user);
      localStorage.setItem("email", data.user.email);
    });
  };

  useEffect(() => {
    let user = getDecodedToken();
    if (hasBusiness() && window.location.pathname === "/") {
      navigate(`/${user?.businessId}/dashboard`);
    }
  }, [navigate]);

  const handleReset = () => {
    setPhone("");
    setShowOTP(false);
    setUser(null);
    setTimer(30);
    setOtp("");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
      if (timer === 0) {
        clearInterval(interval);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const handleResend = () => {
    onCaptchVerify();
    const appVerifier = window.recaptchaVerifier;
    const formatPh = "+" + phone;
    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        toast.success("OTP sent successfully!");
        setTimer(30);
      })
      .catch((error) => {
        toast.error("Failed to send OTP");
      });
  };

  const changeBusiness = (event) => {
    const { name, value } = event.target;
    setBusiness({
      ...business,
      [name]: value,
    });
  };

  const createBusiness = async (data) => {
    try {
      const { email, phone, fullName, password } = business;
      const {
        businessName,
        businessCategory,
        businessOtherCategory,
        pincode,
        ...rem
      } = data;
      if (!businessName || !businessCategory || !pincode) {
        toast.error("Please Enter Required Field !");
        return;
      }
      const fingerprint = await getFingerprint();
      let payload = {
        email,
        password,
        phone,
        fullName,
        businessName,
        businessCategory,
        pincode,
        fingerprint,
        ...signupDetails,
        ...rem,
        position: OWNER_ADMIN,
      };
      if (businessCategory === "Other") {
        payload.businessCategory = businessOtherCategory;
      }
      const result = await createUser(payload);
      if (result.status === 201) {
        const { user } = result.data;
        await localStorage.setItem(
          "token",
          result.headers?.get("x-auth-token"),
        );
        await localStorage.setItem("role", user?.position);
        await localStorage.setItem("userUuid", user?.userUuid);
        await localStorage.setItem("bussinessId", user.preferredBusiness);
        navigate(`/${user.preferredBusiness}/dashboard?new=true`);
        return;
      } else if (result.status === 200) {
        const uid = result.data.preferredBusiness;
        await localStorage.setItem(
          "token",
          result?.headers?.get("x-auth-token"),
        );
        await localStorage.setItem("role", user?.position);
        await localStorage.setItem(
          "bussinessId",
          result.data.preferredBusiness,
        );
        await localStorage.setItem("userUuid", user?.userUuid);
        navigate(`/${uid}/dashboard`);
        return;
      }
    } catch (error) {
      console.error("ERROR", error);
    }
  };

  const checkUser = async (data) => {
    try {
      const result = await checkUserBusiness(data);
      if (result && result?.data?.hasBusiness) {
        const { user } = result.data;
        await localStorage.setItem(
          "token",
          result.headers?.get("x-auth-token"),
        );
        await localStorage.setItem("role", user?.position);
        await localStorage.setItem("userUuid", user?.userUuid);
        await localStorage.setItem("bussinessId", user?.preferredBusiness);

        navigate(`/${user?.preferredBusiness}/dashboard`);
        return true;
      } else {
        if (result.code === "ERR_BAD_REQUEST") {
          // Check if error is due to rejected status
          const errorData = result?.response?.data;
          if (errorData?.error === "Account rejected") {
            return "rejected";
          }
          return;
        } else {
          return false;
        }
      }
    } catch (error) {
      // Check error response for rejected status
      const errorData = error?.response?.data;
      if (errorData?.error === "Account rejected") {
        return "rejected";
      }
      console.error("ERROR", error);
    }
  };

  const handleSignup = async (values) => {
    setSignupDetails(values);

    const { email, password, confirmPassword } = values;
    if (!email || !password || !confirmPassword) {
      toast.error("All fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      setPassword(password);
      setConfirmPassword(confirmPassword);

      const emailCheckResponse = await checkUserBusiness({ email });

      if (emailCheckResponse?.data?.hasBusiness) {
        toast.error("This email is already registered.");
        setLoading(false);
        return;
      }

      if (emailCheckResponse?.data?.hasBusiness === false) {
        toast.info("No business found. Please set up your business below.");
        setBusiness({ email: email, password: password });
        const result = await sendEmail({
          email,
          code: toAlphanumeric(emailOtp),
        });

        if (result?.status === 200) {
          toast.success("Verification email sent successfully!");
          setShowVerigyEmail(true);
        } else {
          toast.error("Failed to send verification email. Please try again.");
        }
        return;
      }

      if (!emailCheckResponse?.data) {
        toast.error("Email address is not found.");
        return;
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "An error occurred. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleResellerSignup = async (values) => {
    const {
      email,
      password,
      confirmPassword,
      firstName,
      lastName,
      phone,
      companyName,
      gstNumber,
      address,
      city,
      state,
      pincode,
      gender,
    } = values;

    if (!email || !password || !confirmPassword) {
      toast.error("All required fields must be filled.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const fingerprint = await getFingerprint();
      const result = await createReseller({
        email,
        password,
        confirmPassword,
        firstName,
        lastName,
        phone,
        companyName,
        gstNumber,
        address,
        city,
        state,
        pincode,
        gender,
        fullName: `${firstName} ${lastName}`,
        fingerprint,
      });

      if (result?.status === 201) {
        const { user } = result.data;
        await localStorage.setItem(
          "token",
          result.headers?.get("x-auth-token"),
        );
        await localStorage.setItem("role", user?.position);
        await localStorage.setItem("userUuid", user?.userUuid);
        await localStorage.setItem("bussinessId", user?.preferredBusiness);
        toast.success("Reseller registered successfully!");
        navigate(`/${user?.preferredBusiness}/dashboard?new=true`);
        return;
      } else if (result?.status === 400) {
        toast.error(
          result?.data?.error || "Registration failed. Please try again.",
        );
      } else {
        toast.error("Registration failed. Please try again.");
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "An error occurred. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSignIn = async () => {
    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const fingerprint = await getFingerprint();
      const response = await checkUser({ email, password, fingerprint });
      if (response?.data?.hasBusiness) {
        const { user } = response.data;
        await localStorage.setItem(
          "token",
          response.headers?.get("x-auth-token"),
        );
        await localStorage.setItem("role", user?.position);
        await localStorage.setItem("userUuid", user?.userUuid);
        await localStorage.setItem("bussinessId", user?.preferredBusiness);
        if (user) {
          navigate(`/${user?.preferredBusiness}/dashboard`);
        } else {
          setError("User not found. Please try again.");
        }
        return;
      }

      if (response === false) {
        toast.error(
          "No business found for this email. Please create a business.",
        );
        return;
      }

      if (response?.data?.error === "INVALID_CREDENTIALS") {
        setError("Email and password do not match.");
        return;
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "An error occurred. Please try again.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handlePasskeySignIn = async () => {
    if (!email) {
      setError(t("PASSKEY.EMAIL_REQ_LOGIN"));
      return;
    }
    setLoading(true);
    setError("");
    try {
      const fingerprint = await getFingerprint();
      const {
        data: { options, challengeKey },
      } = await passkeyService.generateAuthenticationOptions({ email });

      const response = await startAuthentication(options);

      const verificationResp = await passkeyService.verifyAuthentication({
        response,
        challengeKey,
        fingerprint,
      });

      if (verificationResp.data?.hasBusiness) {
        const { user } = verificationResp.data;
        // In axios, headers are lowercase
        const token =
          verificationResp.headers?.["x-auth-token"] ||
          verificationResp.headers?.get?.("x-auth-token");
        if (token) await localStorage.setItem("token", token);
        await localStorage.setItem("role", user?.position);
        await localStorage.setItem("userUuid", user?.userUuid);
        await localStorage.setItem("bussinessId", user?.preferredBusiness);
        navigate(`/${user?.preferredBusiness}/dashboard`);
        toast.success(t("PASSKEY.LOGIN_SUCCESS"));
      } else {
        setError(t("PASSKEY.LOGIN_FAILED"));
      }
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.error ||
          err?.message ||
          t("PASSKEY.LOGIN_CANCELLED"),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAuth = async () => {
    if (showPassword) {
      await handleSignIn();
    } else {
      await handleSignup();
    }
  };

  const togglePasswordVisibility = () => {
    setShoweyePassword((prev) => !prev);
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return "Email is required";
    } else if (!emailRegex.test(value)) {
      return "Enter a valid email";
    }
    return "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(validateEmail(value));
  };

  const handleClickSignup = () => {
    setShowPassword(!showPassword);
    setShowSignup(!showSignup);
    setShowVerigyEmail(false);
    setShowResetPassword(false);
    setShowResellerSignup(false);
    setShowResellerLogin(false);
    setEmployeeLogin(false);
    setError("");
  };

  const handleCloseForgotPassword = () => {
    setShowResetPassword(false);
  };

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  // Theme-based styles
  const themeClasses = useMemo(() => {
    return {
      container:
        theme === "dark"
          ? "bg-gray-900 text-gray-100"
          : "bg-gradient-to-br from-gray-50 to-blue-50 text-gray-900",

      card:
        theme === "dark"
          ? "bg-gray-800 border-gray-700"
          : "bg-white border-gray-200",

      button:
        theme === "dark"
          ? "bg-gray-700 hover:bg-gray-600 border-gray-600"
          : "bg-white hover:bg-gray-50 border-gray-300",

      input:
        theme === "dark"
          ? "bg-gray-700 border-gray-600 text-gray-100"
          : "bg-gray-50 border-gray-300 text-gray-900",

      accentButton:
        theme === "dark"
          ? "bg-blue-600 hover:bg-blue-700"
          : "bg-blue-600 hover:bg-blue-700",

      textMuted: theme === "dark" ? "text-gray-300" : "text-gray-600",

      textPrimary: theme === "dark" ? "text-gray-100" : "text-gray-900",

      border: theme === "dark" ? "border-gray-700" : "border-gray-200",

      divider: theme === "dark" ? "border-gray-700" : "border-gray-300",

      error:
        theme === "dark"
          ? "bg-red-900/20 border-red-800 text-red-200"
          : "bg-red-50 border-red-200 text-red-600",

      success:
        theme === "dark"
          ? "bg-green-900/20 border-green-800 text-green-200"
          : "bg-green-50 border-green-200 text-green-600",
    };
  }, [theme]);

  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const scaleIn = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 0.5, ease: "backOut" },
    },
  };

  const slideIn = {
    hidden: { x: -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.7, ease: "easeOut" },
    },
  };

  const float = {
    initial: { y: 0 },
    animate: {
      y: [0, -10, 0],
      transition: { duration: 3, repeat: Infinity, ease: "easeInOut" },
    },
  };

  return (
    <div
      className={`h-screen w-screen overflow-hidden relative transition-colors duration-300 ${themeClasses.container}`}
    >
      {/* Hidden reCAPTCHA container */}
      <div id='recaptcha-container' className='hidden'></div>

      {/* Theme Toggle */}
      <motion.button
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={toggleTheme}
        className={`fixed top-6 right-6 z-50 p-3 rounded-full shadow-lg transition-all ${theme === "dark" ? "bg-gray-800 border-gray-700 hover:bg-gray-700" : "bg-white border-gray-200 hover:bg-gray-50"} border`}
        aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      >
        {theme === "light" ? (
          <FiMoon
            className={`${theme === "dark" ? "text-yellow-300" : "text-gray-700"} text-lg`}
          />
        ) : (
          <FiSun className='text-yellow-400 text-lg' />
        )}
      </motion.button>

      {/* Background Elements - FIXED: Added pointer-events-none and lower z-index */}
      <div className='absolute inset-0 overflow-hidden pointer-events-none z-0'>
        {/* Subtle Patterns */}
        <motion.div
          animate={{
            x: [0, 100, 0],
            y: [0, -100, 0],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "linear",
          }}
          className={`absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-10 pointer-events-none ${theme === "dark" ? "bg-blue-900" : "bg-blue-100"}`}
        />

        <motion.div
          animate={{
            x: [0, -150, 0],
            y: [0, 150, 0],
          }}
          transition={{
            duration: 35,
            repeat: Infinity,
            ease: "linear",
          }}
          className={`absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full opacity-10 pointer-events-none ${theme === "dark" ? "bg-blue-900" : "bg-blue-100"}`}
        />

        {/* Grid Pattern */}
        <div
          className='absolute inset-0 pointer-events-none'
          style={{
            backgroundImage: `linear-gradient(to right, ${theme === "dark" ? "rgba(59, 130, 246, 0.05)" : "rgba(59, 130, 246, 0.03)"} 1px, transparent 1px),
                            linear-gradient(to bottom, ${theme === "dark" ? "rgba(59, 130, 246, 0.05)" : "rgba(59, 130, 246, 0.03)"} 1px, transparent 1px)`,
            backgroundSize: "50px 50px",
          }}
        />
      </div>

      {/* Floating Icons - FIXED: Added pointer-events-none */}
      {[...Array(8)].map((_, i) => (
        <motion.div
          key={i}
          className={`absolute pointer-events-none z-0 ${theme === "dark" ? "text-blue-800" : "text-blue-200"}`}
          style={{
            left: `${10 + i * 10}%`,
            top: `${20 + i * 7}%`,
            fontSize: `${24 + i * 4}px`,
          }}
          animate={{
            y: [0, Math.random() * 40 - 20, 0],
            x: [0, Math.random() * 30 - 15, 0],
            rotate: [0, 360],
          }}
          transition={{
            duration: Math.random() * 10 + 10,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          {i % 4 === 0 ? (
            <FiTrendingUp />
          ) : i % 4 === 1 ? (
            <FiBarChart2 />
          ) : i % 4 === 2 ? (
            <FiUsers />
          ) : (
            <FiAward />
          )}
        </motion.div>
      ))}

      {/* Main Content - FIXED: Added higher z-index */}
      <div className='relative h-full w-full flex items-center justify-center p-2 lg:p-8 z-10'>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className='w-full max-w-8xl h-full lg:h-auto flex flex-col lg:flex-row items-center justify-center lg:justify-between gap-4 lg:gap-16 px-2 lg:px-8 z-20 py-4 lg:py-0'
        >
          {/* Left Side - Hero Section */}
          <motion.div
            initial='hidden'
            animate='visible'
            variants={slideIn}
            className='lg:w-2/5 xl:w-2/5 flex flex-col items-center lg:items-start text-center lg:text-left ml-0 lg:ml-8 z-20 shrink-0'
          >
            {/* Logo */}
            <motion.div variants={float} className='relative mb-4 lg:mb-10'>
              <div
                className={`relative p-3 lg:p-6 rounded-xl shadow-md border ${theme === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"}`}
              >
                <img
                  src={icon}
                  alt='DukanBuddy Logo'
                  className='w-16 h-16 lg:w-28 lg:h-28 rounded-lg outline-none'
                />
              </div>
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                className='absolute -top-4 -right-4 pointer-events-none'
              >
                <FiStar
                  className={`${theme === "dark" ? "text-yellow-500" : "text-yellow-400"} text-2xl`}
                />
              </motion.div>
            </motion.div>

            {/* Hero Text */}
            <motion.div variants={fadeInUp} className='scale-90 lg:scale-100'>
              <h1
                className={`text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-2 lg:mb-6 ${themeClasses.textPrimary}`}
              >
                <span
                  className={
                    theme === "dark" ? "text-blue-400" : "text-blue-800"
                  }
                >
                  dukan
                </span>
                <span
                  className={
                    theme === "dark" ? "text-blue-300" : "text-blue-600"
                  }
                >
                  Buddy
                </span>
              </h1>

              <motion.p
                variants={fadeInUp}
                className={`text-sm lg:text-lg xl:text-xl leading-relaxed mb-4 lg:mb-8 ${themeClasses.textMuted}`}
              >
                Transform your business with
                <span
                  className={`font-semibold ${theme === "dark" ? "text-blue-300" : "text-blue-600"}`}
                >
                  {" "}
                  smart tools
                </span>{" "}
                and
                <span
                  className={`font-semibold ${theme === "dark" ? "text-blue-300" : "text-blue-600"}`}
                >
                  {" "}
                  real-time insights
                </span>
              </motion.p>
            </motion.div>

            {/* Stats Cards - Compact on mobile */}
            <motion.div
              variants={fadeInUp}
              className='grid grid-cols-2 gap-2 lg:gap-4 mb-4 lg:mb-8 w-full scale-90 lg:scale-100 origin-center lg:origin-left'
            >
              <motion.div
                whileHover={{ y: -5 }}
                className={`p-2 lg:p-4 rounded-2xl border shadow-lg ${theme === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-blue-100"}`}
              >
                <div className='flex items-center gap-2 lg:gap-3'>
                  <div
                    className={`p-1.5 lg:p-2 rounded-lg ${theme === "dark" ? "bg-blue-900/30" : "bg-blue-100"}`}
                  >
                    <FiUsers
                      className={
                        theme === "dark"
                          ? "text-blue-300"
                          : "text-blue-600 text-lg lg:text-xl"
                      }
                    />
                  </div>
                  <div>
                    <div
                      className={`text-lg lg:text-xl font-bold ${theme === "dark" ? "text-blue-200" : "text-blue-900"}`}
                    >
                      24/7
                    </div>
                    <div
                      className={`${theme === "dark" ? "text-blue-300" : "text-blue-700"} text-[10px] lg:text-sm`}
                    >
                      Support
                    </div>
                  </div>
                </div>
              </motion.div>

              <motion.div
                whileHover={{ y: -5 }}
                className={`p-2 lg:p-4 rounded-2xl border shadow-lg ${theme === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-blue-100"}`}
              >
                <div className='flex items-center gap-2 lg:gap-3'>
                  <div
                    className={`p-1.5 lg:p-2 rounded-lg ${theme === "dark" ? "bg-blue-900/30" : "bg-blue-100"}`}
                  >
                    <FiTrendingUp
                      className={
                        theme === "dark"
                          ? "text-blue-300"
                          : "text-blue-600 text-lg lg:text-xl"
                      }
                    />
                  </div>
                  <div>
                    <div
                      className={`text-lg lg:text-xl font-bold ${theme === "dark" ? "text-blue-200" : "text-blue-900"}`}
                    >
                      99%
                    </div>
                    <div
                      className={`${theme === "dark" ? "text-blue-300" : "text-blue-700"} text-[10px] lg:text-sm`}
                    >
                      Success
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>

            {/* Features List - Hidden on small mobile to save vertical space */}
            <motion.div
              variants={fadeInUp}
              className='hidden md:block space-y-4 w-full'
            >
              <motion.div
                whileHover={{ x: 10 }}
                className={`flex items-center gap-4 p-3 rounded-xl border ${theme === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"}`}
              >
                <div className='p-1.5 bg-blue-500 rounded-lg'>
                  <FiZap className='text-white text-lg' />
                </div>
                <span className={themeClasses.textPrimary}>
                  Lightning Fast Performance
                </span>
              </motion.div>

              <motion.div
                whileHover={{ x: 10 }}
                className={`flex items-center gap-4 p-3 rounded-xl border ${theme === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"}`}
              >
                <div className='p-2 bg-blue-500 rounded-lg'>
                  <FiShield className='text-white text-lg' />
                </div>
                <span className={themeClasses.textPrimary}>
                  Enterprise-grade Security
                </span>
              </motion.div>

              <motion.div
                whileHover={{ x: 10 }}
                className={`flex items-center gap-4 p-3 rounded-xl border ${theme === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"}`}
              >
                <div className='p-2 bg-blue-500 rounded-lg'>
                  <FiClock className='text-white text-lg' />
                </div>
                <span className={themeClasses.textPrimary}>
                  24/7 Customer Support
                </span>
              </motion.div>
            </motion.div>
          </motion.div>

          {/* Right Side - Login Card - FIXED: Added proper z-index */}
          <motion.div
            initial='hidden'
            animate='visible'
            variants={scaleIn}
            className='lg:w-3/5 xl:w-2/5 flex justify-end relative z-30 shrink'
          >
            <div className='w-full max-w-lg xl:max-w-2xl mr-0 lg:mr-8 scale-[0.85] md:scale-95 lg:scale-100 origin-center lg:origin-right'>
              <AnimatePresence mode='wait'>
                {user ? (
                  <motion.div
                    key='business-form'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className={`rounded-3xl shadow-2xl border p-8 relative z-40 ${themeClasses.card}`}
                  >
                    <BusinessForm
                      business={business}
                      changeBusiness={changeBusiness}
                      createBusiness={createBusiness}
                    />
                  </motion.div>
                ) : showOTP ? (
                  <motion.div
                    key='otp-form'
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    className={`rounded-3xl shadow-2xl border p-8 relative z-40 ${themeClasses.card}`}
                  >
                    {/* OTP Animation */}
                    <motion.div
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      className='relative w-24 h-24 mx-auto mb-6'
                    >
                      <div
                        className={`relative w-full h-full rounded-full flex items-center justify-center shadow-xl border ${theme === "dark" ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"}`}
                      >
                        <FiLock className='text-4xl text-blue-600' />
                      </div>
                    </motion.div>

                    <motion.h2
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      className={`text-3xl font-bold text-center mb-2 ${themeClasses.textPrimary}`}
                    >
                      Secure Verification
                    </motion.h2>

                    <motion.p
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className={`text-center mb-8 ${themeClasses.textMuted}`}
                    >
                      Enter the 6-digit code sent to
                      <br />
                      <span
                        className={`font-semibold ${theme === "dark" ? "text-blue-300" : "text-blue-700"}`}
                      >
                        +{phone}
                      </span>
                    </motion.p>

                    <div className='space-y-8'>
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        OTPLength={6}
                        otpType='number'
                        disabled={false}
                        autoFocus
                        className='flex justify-center gap-3'
                        inputClassName={`!w-14 !h-14 text-center text-2xl font-bold rounded-xl focus:ring-4 focus:ring-blue-100 outline-none transition-all shadow-md hover:shadow-lg ${
                          theme === "dark"
                            ? "bg-gray-700 border-2 border-gray-600 focus:border-blue-500 focus:ring-blue-900/30 text-gray-100"
                            : "bg-white border-2 border-blue-200 focus:border-blue-500 focus:ring-blue-100 text-gray-900"
                        }`}
                      />

                      <div className='text-center'>
                        {timer > 0 ? (
                          <motion.div
                            key='timer'
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className={`inline-flex items-center gap-2 ${themeClasses.textMuted}`}
                          >
                            <div className='w-2 h-2 bg-blue-500 rounded-full animate-ping' />
                            Resend OTP in{" "}
                            <span
                              className={`font-semibold ${theme === "dark" ? "text-blue-300" : "text-blue-700"}`}
                            >
                              {timer}s
                            </span>
                          </motion.div>
                        ) : (
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={handleResend}
                            className={`inline-flex items-center gap-2 font-medium px-4 py-2 rounded-lg transition-all ${
                              theme === "dark"
                                ? "text-blue-300 hover:text-blue-200 bg-blue-900/20 hover:bg-blue-900/30"
                                : "text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100"
                            }`}
                          >
                            <FiArrowRight />
                            Resend OTP
                          </motion.button>
                        )}
                      </div>

                      <div className='flex gap-4'>
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={handleReset}
                          className={`flex-1 border-2 font-semibold py-3 rounded-xl transition-all flex items-center justify-center gap-2 ${
                            theme === "dark"
                              ? "border-gray-600 text-blue-300 hover:bg-gray-700"
                              : "border-blue-200 text-blue-700 hover:bg-blue-50"
                          }`}
                        >
                          <FiArrowRight className='rotate-180' />
                          Back
                        </motion.button>

                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={onOTPVerify}
                          disabled={otp.length !== 6 || loading}
                          className='flex-1 bg-blue-600 text-white font-semibold py-3 rounded-xl hover:bg-blue-700 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                          {loading && <CgSpinner className='animate-spin' />}
                          {loading ? "Verifying..." : "Verify & Continue"}
                          <FiArrowRight />
                        </motion.button>
                      </div>
                    </div>
                  </motion.div>
                ) : (
                  <motion.div
                    key='auth-container'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className={`rounded-3xl shadow-2xl border p-4 lg:p-6 relative z-40 ${themeClasses.card}`}
                  >
                    {/* Unified Header */}
                    <div className='flex justify-between items-start mb-4 lg:mb-6'>
                      <div>
                        <h2
                          className={`text-2xl lg:text-3xl font-bold ${themeClasses.textPrimary}`}
                        >
                          {showResetPassword
                            ? "Reset Password"
                            : showResellerSignup
                              ? "Partner With Us"
                              : showResellerLogin
                                ? "Reseller Login"
                                : employeeLogin
                                  ? "Employee Portal"
                                  : showVerifyEmail
                                    ? "Verify Email"
                                    : showSignup
                                      ? "Join Us Today"
                                      : "Welcome Back"}
                        </h2>
                        <p
                          className={`mt-1 lg:mt-2 text-sm lg:text-base ${themeClasses.textMuted}`}
                        >
                          {showResetPassword
                            ? "Recover access to your account"
                            : showResellerSignup
                              ? "Start your reseller journey"
                              : showResellerLogin
                                ? "Access your partner dashboard"
                                : employeeLogin
                                  ? "Sign in to your workplace"
                                  : showVerifyEmail
                                    ? "Enter your verification code"
                                    : showSignup
                                      ? "Create your account in seconds"
                                      : "Sign in to your account"}
                        </p>
                      </div>

                      <motion.div
                        whileHover={{ rotate: 180 }}
                        transition={{ duration: 0.3 }}
                        className={`p-2 lg:p-3 rounded-xl ${theme === "dark" ? "bg-gray-700" : "bg-blue-50"}`}
                      >
                        <FiGlobe
                          className={`${theme === "dark" ? "text-blue-300" : "text-blue-600"} text-lg lg:text-xl`}
                        />
                      </motion.div>
                    </div>

                    <AnimatePresence mode='wait'>
                      {showResetPassword ? (
                        <ForgotPassword
                          onBack={handleCloseForgotPassword}
                          theme={theme}
                        />
                      ) : showResellerSignup ? (
                        <motion.div
                          key='reseller-signup'
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                        >
                          <ResellerSignupForm
                            handleResellerSignup={handleResellerSignup}
                            onBack={() => setShowResellerSignup(false)}
                            theme={theme}
                          />
                        </motion.div>
                      ) : showResellerLogin ? (
                        <motion.div
                          key='reseller-login'
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                        >
                          <ResellerLogin
                            onBack={() => setShowResellerLogin(false)}
                            theme={theme}
                          />
                        </motion.div>
                      ) : employeeLogin ? (
                        <motion.div
                          key='employee-login'
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                        >
                          <EmployeeLogin
                            onBack={() => setEmployeeLogin(false)}
                            theme={theme}
                          />
                        </motion.div>
                      ) : showVerifyEmail ? (
                        <motion.div
                          key='verify-email'
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                        >
                          <VerifyEmailPopup
                            verificationToken={`${emailOtp}`}
                            setUser={setUser}
                            user={business}
                          />
                        </motion.div>
                      ) : showSignup ? (
                        <motion.div
                          key='signup-form'
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                        >
                          <SignupForm
                            handleSignup={handleSignup}
                            theme={theme}
                          />
                        </motion.div>
                      ) : (
                        <motion.div
                          key='login-form-content'
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          className='space-y-6'
                        >
                          {/* Email Field */}
                          <motion.div
                            whileFocus={{ scale: 1.01 }}
                            className='relative'
                          >
                            <TextField
                              fullWidth
                              label='Email Address'
                              type='email'
                              value={email}
                              onChange={handleEmailChange}
                              error={!!emailError}
                              helperText={emailError}
                              variant='outlined'
                              size='medium'
                              className='mb-2'
                              InputProps={{
                                className:
                                  theme === "dark" ? "text-gray-100" : "",
                              }}
                              sx={{
                                "& .MuiInputLabel-root": {
                                  color:
                                    theme === "dark" ? "#9ca3af" : undefined,
                                },
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "12px",
                                  backgroundColor:
                                    theme === "dark" ? "#374151" : "#f9fafb",
                                  color:
                                    theme === "dark" ? "#f3f4f6" : "#111827",
                                  "& fieldset": {
                                    borderColor:
                                      theme === "dark" ? "#4b5563" : "#d1d5db",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#3b82f6",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#3b82f6",
                                    borderWidth: "2px",
                                  },
                                },
                                "& .MuiFormHelperText-root": {
                                  color:
                                    theme === "dark" ? "#ef4444" : undefined,
                                },
                              }}
                            />
                          </motion.div>

                          {/* Password Field */}
                          <motion.div
                            whileFocus={{ scale: 1.01 }}
                            className='relative'
                          >
                            <TextField
                              fullWidth
                              label='Password'
                              type={showeyePassword ? "text" : "password"}
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              variant='outlined'
                              size='medium'
                              InputProps={{
                                className:
                                  theme === "dark" ? "text-gray-100" : "",
                                endAdornment: (
                                  <motion.button
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    type='button'
                                    onClick={togglePasswordVisibility}
                                    className={`p-1 ${theme === "dark" ? "text-gray-400 hover:text-blue-300" : "text-gray-400 hover:text-blue-600"}`}
                                  >
                                    {showeyePassword ? (
                                      <FaEyeSlash />
                                    ) : (
                                      <FaEye />
                                    )}
                                  </motion.button>
                                ),
                              }}
                              sx={{
                                "& .MuiInputLabel-root": {
                                  color:
                                    theme === "dark" ? "#9ca3af" : undefined,
                                },
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "12px",
                                  backgroundColor:
                                    theme === "dark" ? "#374151" : "#f9fafb",
                                  color:
                                    theme === "dark" ? "#f3f4f6" : "#111827",
                                  "& fieldset": {
                                    borderColor:
                                      theme === "dark" ? "#4b5563" : "#d1d5db",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#3b82f6",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#3b82f6",
                                    borderWidth: "2px",
                                  },
                                },
                              }}
                            />
                          </motion.div>

                          {/* Error Message */}
                          {error && (
                            <motion.div
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              className={`p-4 rounded-xl border ${themeClasses.error}`}
                            >
                              <div className='flex items-center gap-3'>
                                <div
                                  className={`p-2 rounded-lg ${theme === "dark" ? "bg-red-900/30" : "bg-red-100"}`}
                                >
                                  <FiShield className='text-lg' />
                                </div>
                                <span className='font-medium'>{error}</span>
                              </div>
                            </motion.div>
                          )}

                          {/* Action Links */}
                          <div className='flex justify-between items-center pt-2'>
                            <motion.button
                              whileHover={{ scale: 1.05, x: 5 }}
                              whileTap={{ scale: 0.95 }}
                              onClick={() => setShowResetPassword(true)}
                              className={`text-sm font-medium flex items-center gap-1 ${
                                theme === "dark"
                                  ? "text-blue-300 hover:text-blue-200"
                                  : "text-blue-600 hover:text-blue-700"
                              }`}
                            >
                              Forgot Password?
                              <FiChevronRight />
                            </motion.button>

                            <motion.button
                              whileHover={{ scale: 1.05, x: 5 }}
                              whileTap={{ scale: 0.95 }}
                              onClick={() => setShowResellerLogin(true)}
                              className={`text-sm font-medium flex items-center gap-1 ${
                                theme === "dark"
                                  ? "text-blue-300 hover:text-blue-200"
                                  : "text-blue-600 hover:text-blue-700"
                              }`}
                            >
                              Reseller Login
                              <FiChevronRight />
                            </motion.button>

                            <motion.button
                              whileHover={{ scale: 1.05, x: 5 }}
                              whileTap={{ scale: 0.95 }}
                              onClick={() => setEmployeeLogin(true)}
                              className={`text-sm font-medium flex items-center gap-1 ${
                                theme === "dark"
                                  ? "text-blue-300 hover:text-blue-200"
                                  : "text-blue-600 hover:text-blue-700"
                              }`}
                            >
                              Employee Login
                              <FiChevronRight />
                            </motion.button>
                          </div>

                          {/* Sign In Button */}
                          <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={handleAuth}
                            disabled={loading || !!emailError}
                            className='w-full bg-blue-600 text-white font-semibold py-4 rounded-xl hover:bg-blue-700 transition-all flex items-center justify-center gap-3 mt-6 disabled:opacity-50 disabled:cursor-not-allowed group'
                          >
                            {loading ? (
                              <CgSpinner className='animate-spin text-2xl' />
                            ) : (
                              <>
                                <motion.div
                                  whileHover={{ rotate: 360 }}
                                  transition={{ duration: 0.5 }}
                                  className='p-2 bg-white/20 rounded-lg'
                                >
                                  <FiLogIn className='text-xl' />
                                </motion.div>
                                <span className='text-lg'>
                                  Sign In to Dashboard
                                </span>
                                <FiArrowRight className='group-hover:translate-x-2 transition-transform' />
                              </>
                            )}
                          </motion.button>

                          {/* Passkey Sign In Button */}
                          <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={handlePasskeySignIn}
                            disabled={loading || !!emailError || !email}
                            className={`w-full ${theme === "dark" ? "bg-gray-700 text-white" : "bg-gray-100 text-gray-800"} font-semibold py-4 rounded-xl hover:${theme === "dark" ? "bg-gray-600" : "bg-gray-200"} transition-all flex items-center justify-center gap-3 mt-3 disabled:opacity-50 disabled:cursor-not-allowed`}
                          >
                            <MdFingerprint className='text-2xl' />
                            <span className='text-lg'>
                              {t("PASSKEY.SIGN_IN")}
                            </span>
                          </motion.button>
                        </motion.div>
                      )}
                    </AnimatePresence>

                    {/* Toggle Signup/Signin - Only show for standard flows */}
                    {!(
                      showResellerLogin ||
                      showResellerSignup ||
                      employeeLogin ||
                      showVerifyEmail ||
                      showResetPassword
                    ) && (
                      <div className='text-center mt-8'>
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          onClick={handleClickSignup}
                          className={`transition-colors flex items-center justify-center gap-2 mx-auto group ${
                            theme === "dark"
                              ? "text-gray-400 hover:text-gray-300"
                              : "text-gray-600 hover:text-gray-800"
                          }`}
                        >
                          {showSignup ? (
                            <>
                              Already have an account?{" "}
                              <span
                                className={`font-semibold group-hover:text-blue-700 ${
                                  theme === "dark"
                                    ? "text-blue-300 group-hover:text-blue-200"
                                    : "text-blue-600 group-hover:text-blue-700"
                                }`}
                              >
                                Sign In Here
                                <FiArrowRight className='inline ml-1 group-hover:translate-x-1 transition-transform' />
                              </span>
                            </>
                          ) : (
                            <>
                              New to DukanBuddy?{" "}
                              <span
                                className={`font-semibold group-hover:text-blue-700 ${
                                  theme === "dark"
                                    ? "text-blue-300 group-hover:text-blue-200"
                                    : "text-blue-600 group-hover:text-blue-700"
                                }`}
                              >
                                Create Account
                                <FiUserPlus className='inline ml-1 group-hover:scale-110 transition-transform' />
                              </span>
                            </>
                          )}
                        </motion.button>

                        <div className='flex flex-col gap-2 mt-4'>
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => setShowResellerSignup(true)}
                            className={`text-sm font-medium transition-colors flex items-center justify-center gap-2 mx-auto group ${
                              theme === "dark"
                                ? "text-gray-400 hover:text-gray-300"
                                : "text-gray-600 hover:text-gray-800"
                            }`}
                          >
                            Want to partner?{" "}
                            <span
                              className={`font-semibold group-hover:text-blue-700 ${
                                theme === "dark"
                                  ? "text-blue-300 group-hover:text-blue-200"
                                  : "text-blue-600 group-hover:text-blue-700"
                              }`}
                            >
                              Sign up as Reseller
                              <FiAward className='inline ml-1 group-hover:scale-110 transition-transform' />
                            </span>
                          </motion.button>
                        </div>
                      </div>
                    )}

                    {/* Divider & Google Sign In - Only show for standard login/signup */}
                    {!(
                      showResellerLogin ||
                      showResellerSignup ||
                      employeeLogin ||
                      showVerifyEmail ||
                      showResetPassword
                    ) && (
                      <>
                        <div className='relative my-8'>
                          <div className='absolute inset-0 flex items-center'>
                            <div
                              className={`w-full border-t ${themeClasses.divider}`}
                            ></div>
                          </div>
                          <div className='relative flex justify-center'>
                            <span
                              className={`px-4 text-sm font-medium ${theme === "dark" ? "bg-gray-800 text-gray-400" : "bg-white text-gray-500"}`}
                            >
                              Or continue with
                            </span>
                          </div>
                        </div>

                        <motion.button
                          whileHover={{
                            scale: 1.02,
                            y: -2,
                          }}
                          whileTap={{ scale: 0.98 }}
                          onClick={handleGoogleSignIn}
                          className={`w-full border-2 font-semibold py-3 rounded-xl transition-all flex items-center justify-center gap-4 group ${
                            theme === "dark"
                              ? "bg-gray-800 border-gray-700 text-gray-300 hover:border-blue-700 hover:bg-gray-700"
                              : "bg-white border-gray-200 text-gray-700 hover:border-blue-300 hover:bg-blue-50"
                          }`}
                        >
                          <div
                            className={`p-2 rounded-lg border transition-colors ${
                              theme === "dark"
                                ? "bg-gray-700 border-gray-600 group-hover:border-blue-700"
                                : "bg-white border-gray-100 group-hover:border-blue-200"
                            }`}
                          >
                            <img
                              src={googleLogo}
                              alt='Google'
                              className='w-5 h-5'
                            />
                          </div>
                          <span>Continue with Google</span>
                          <FiArrowRight
                            className={`transition-colors ${
                              theme === "dark"
                                ? "text-gray-500 group-hover:text-blue-400"
                                : "text-gray-400 group-hover:text-blue-500"
                            }`}
                          />
                        </motion.button>
                      </>
                    )}

                    {/* Footer */}
                    <div
                      className={`mt-8 text-center text-xs ${themeClasses.textMuted}`}
                    >
                      By continuing, you agree to our{" "}
                      <a
                        href='/terms'
                        className={`font-medium hover:underline ${
                          theme === "dark"
                            ? "text-blue-300 hover:text-blue-200"
                            : "text-blue-600 hover:text-blue-700"
                        }`}
                      >
                        Terms of Service
                      </a>{" "}
                      and{" "}
                      <a
                        href='/privacy'
                        className={`font-medium hover:underline ${
                          theme === "dark"
                            ? "text-blue-300 hover:text-blue-200"
                            : "text-blue-600 hover:text-blue-700"
                        }`}
                      >
                        Privacy Policy
                      </a>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Corner Accents - FIXED: Added pointer-events-none */}
      <motion.div
        animate={{
          rotate: [0, 360],
        }}
        transition={{
          duration: 40,
          repeat: Infinity,
          ease: "linear",
        }}
        className={`absolute top-0 left-0 w-64 h-64 rounded-br-full opacity-10 pointer-events-none z-0 ${
          theme === "dark" ? "bg-blue-900" : "bg-blue-100"
        }`}
      />

      <motion.div
        animate={{
          rotate: [0, -360],
        }}
        transition={{
          duration: 45,
          repeat: Infinity,
          ease: "linear",
        }}
        className={`absolute bottom-0 right-0 w-96 h-96 rounded-tl-full opacity-10 pointer-events-none z-0 ${
          theme === "dark" ? "bg-blue-900" : "bg-blue-100"
        }`}
      />
    </div>
  );
}

export default App;
